<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="22"
    viewBox="0 0 16 22"
    fill="none"
  >
    <path
      d="M9.67139 1.05664L7.46436 6.30176L7.17236 6.99512H14.4292L6.23779 19.3135L7.23779 10.9912L7.30518 10.4316H1.1626L3.39307 1.05664H9.67139Z"
      fill="#FF83E7"
      stroke="#FF83E7"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2LogosUtilitiesNav'
})
</script>
